// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".blog-post{transition:all .1s ease-in-out}.blog-post iframe{margin:40px 0}.blog-post li>p{padding:10px}.blog-post a{transition:all .1s ease-in-out}.blog-post a:hover{color:#0884e2!important}@media only screen and (max-device-width:600px){.blog-post iframe,.blog-post img{width:100%}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
